import { CircleHelp } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Button } from '~/components/ui/button'

function NotFound() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className="w-screen h-dvh bg-background flex flex-col justify-center items-center gap-6">
      <CircleHelp width={48} height={48} />
      <p className="font-bold font-primary">
        {t('not.found.message')}
      </p>
      <Button className="rounded-lg px-4 py-2" type="button" onClick={() => navigate('/')}>
        {t('common.back')}
      </Button>
    </div>
  )
}

export default NotFound
